import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { getDatabase, ref, onValue, update } from "firebase/database";
import ReactPlayer from "react-player";
import { app } from "../firebase/firebaseconfig";

const VideoDetails = () => {
  const { channelId, videoId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [video, setVideo] = useState(null);
  const [isApproving, setIsApproving] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const [isUploaded, setIsUploaded] = useState(
    sessionStorage.getItem(`uploadStatus-${videoId}`) === "true"
  );

  // Determine userRole based on the URL
  const userRole = location.pathname.includes("/youtuber/")
    ? "youtuber"
    : "editor";

  useEffect(() => {
    const db = getDatabase(app);
    const videoRef = ref(db, `channels/${channelId}/videos/${videoId}`);

    onValue(videoRef, (snapshot) => {
      const data = snapshot.val();
      setVideo(data);
    });
  }, [channelId, videoId]);

  const handleApproval = () => {
    if (!isUploaded) {
      // Check if the video has not been uploaded yet
      setIsApproving(true); // Disable the button
      window.location.href = `https://quicktube-backend-1.onrender.com/login?channelId=${channelId}&videoId=${videoId}`;
    }
    //   setIsApproving(true); // Disable the button
    //   window.location.href = `localhost:8080/login?channelId=${channelId}&videoId=${videoId}`;
    // }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const authSuccess = searchParams.get("authSuccess");
    const uploadInitiated = sessionStorage.getItem(
      `uploadInitiated-${videoId}`
    );

    if (authSuccess && !isUploaded && !uploadInitiated) {
      sessionStorage.setItem(`uploadInitiated-${videoId}`, "true");
      handleVideoUpload().then(() => {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("authSuccess");
        window.history.pushState({}, "", newUrl);
      });
    }
  }, [location.search, isUploaded, videoId]);

  const handleVideoUpload = async () => {
    console.log("handleVideoUpload called", { isUploaded, isApproving });

    if (!isUploaded && !isApproving) {
      console.log("Initiating upload...");
      setIsApproving(true);
      setUploadStatus("Uploading...");
      try {
        const response = await fetch(
          "https://quicktube-backend-1.onrender.com/youtubeUpload",
          {
            // const response = await fetch("localhost:8080/youtubeUpload", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              channelId: channelId,
              videoId: videoId,
              videoUrl: video?.videoUrl,
              title: video?.title,
              description: video?.description,
              tags: video?.tags,
            }),
          }
        );
        const responseData = await response.json();
        if (responseData.message === "Upload successful") {
          console.log("Upload successful:", responseData);
          setUploadStatus("Upload successful!");
          setIsUploaded(true);
          sessionStorage.setItem(`uploadStatus-${videoId}`, "true");

          // Update approvalStatus to "Approved" in Firebase Realtime Database
          const db = getDatabase(app);
          const videoRef = ref(db, `channels/${channelId}/videos/${videoId}`);
          update(videoRef, { approvalStatus: "Approved" });
        } else {
          throw new Error("Upload not successful");
        }
      } catch (error) {
        console.error("Upload failed:", error);
        setUploadStatus("Upload failed. Please try again.");
      } finally {
        setIsApproving(false); // Clear flag regardless of success or failure
      }
    }
  };

  if (!video) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex justify-center flex-row h-[calc(100%-56px)] bg-black font-['Gilroy']">
      <div className="w-full max-w-[1280px] flex flex-col lg:flex-row">
        <div className="flex  flex-col lg:w-[calc(100%-350px)] xl:w-[calc(100%-400px)] px-4 py-3 lg:py-6 overflow-y-auto">
          <div className="h-[200px] md:h-[400px] lg:h-[200px] xl:h-[550px] ml-[-16px] lg:ml-0 mr-[-16px] lg:mr-0">
            <ReactPlayer
              url={video?.videoUrl} // Use your video URL here
              controls
              width="100%"
              height="100%"
              playing={true}
              className="rounded-2xl bg-[#09090b]"
            />
          </div>
          <div className="flex flex-row justify-between mt-4 align-middle items-center ">
            <div className="text-white max-w-[47rem] font-bold text-sm md:text-xl line-clamp-2">
              {video?.title}
            </div>
            <div className="flex justify-end items-end flex-row">
              {userRole === "youtuber" &&
              video?.approvalStatus === "Pending" ? (
                <button
                  className="inline-flex items-center px-3 py-2 rounded-full text-xs font-semibold bg-indigo-700 hover:bg-green-500 text-white border-[0.3px] border-white transition-colors duration-200"
                  onClick={handleApproval}
                >
                  <svg
                    className="-ml-0.5 mr-1.5 h-2 w-2 text-white hover:text-white fill-current"
                    viewBox="0 0 8 8"
                  >
                    <circle cx="4" cy="5" r="3" />
                  </svg>
                  Approve
                </button>
              ) : video?.approvalStatus === "Approved" ? (
                // Adjusted styles for the "Approved" state
                <button
                  className="inline-flex items-center px-3 py-2 rounded-full text-xs font-semibold bg-green-500 text-white border-[0.3px] border-white transition-colors duration-150"
                  disabled
                >
                  <svg
                    className="-ml-0.5 mr-1.5 h-2 w-2 text-white fill-current"
                    viewBox="0 0 8 8"
                  >
                    <circle cx="4" cy="5" r="3" />
                  </svg>
                  Approved
                </button>
              ) : (
                <span className="inline-flex items-center px-3 py-2 rounded-full text-xs font-medium bg-[#09090b] text-orange-500 border-[0.3px] border-orange-500">
                  <svg
                    className="-ml-0.5 mr-1.5 h-2 w-2 text-orange-500"
                    fill="currentColor"
                    viewBox="0 0 8 8"
                  >
                    <circle cx="4" cy="4" r="3" />
                  </svg>
                  {video?.approvalStatus}
                </span>
              )}
            </div>
          </div>
          <div className="text-white/[0.7] text-md mt-3 bg-[#09090b] p-3 rounded-lg">
            <span className="font-semibold text-white">Description : </span>{" "}
            {video?.description} {/* Displaying the description */}
          </div>
          <div className="text-white/[0.7] text-md mt-2 bg-[#09090b] p-3 rounded-lg">
            <span className="font-semibold text-white">Tags : </span>
            {Array.isArray(video?.tags)
              ? video.tags.map((tag, index) => (
                  <span
                    key={index}
                    className="bg-[#5E17EB] rounded-full px-2 py-1 font-medium ml-1"
                  >
                    {tag.trim()}
                  </span>
                ))
              : typeof video?.tags === "string" &&
                video.tags.split(",").map((tag, index) => (
                  <span
                    key={index}
                    className="bg-[#5E17EB] rounded-full px-2 py-1 font-medium ml-1"
                  >
                    {tag.trim()}
                  </span>
                ))}
          </div>
        </div>
        {/* Assuming you want to keep the related videos section */}
        <div className="flex flex-col overflow-y-auto lg:w-[350px] xl:w-[400px]">
          <div className="flex flex-col p-3 items-center h-[34.4rem] relative transform w-full overflow-hidden rounded-3xl Gilroy-Medium drop-shadow-lg border-[1px] border-[#1f2734] shadow-2 hover:shadow-lg text-left shadow-xl transition-all sm:my-6 sm:w-full sm:max-w-lg">
            <div className="flex flex-col justify-between h-full">
              <div class="flex items-start gap-2.5 p-2">
                <img class="w-7 h-7 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Jese image"/>
                <div class="flex flex-col gap-1 w-full max-w-[320px]">
                  <div class="flex items-center space-x-2 rtl:space-x-reverse">
                    <span class="text-sm Gilroy-SemiBold text-white dark:text-white">
                      Bonnie Green
                    </span>
                    <span class="text-sm font-normal text-gray-500 dark:text-gray-400">
                      11:46
                    </span>
                  </div>
                  <div class="flex flex-col leading-1.5 p-4 border-gray-200 bg-gray-900 rounded-e-xl rounded-es-xl dark:bg-gray-700">
                    <p class="text-sm font-normal text-white dark:text-white">
                      {" "}
                      That's awesome. I think our users will really appreciate
                      the improvements.
                    </p>
                  </div>
                  <span class="text-sm font-normal text-gray-500 dark:text-gray-400">
                    Delivered
                  </span>
                </div>
                <button
                  id="dropdownMenuIconButton"
                  data-dropdown-toggle="dropdownDots"
                  data-dropdown-placement="bottom-start"
                  class="inline-flex self-center items-center p-2 text-sm font-medium text-center text-white bg-black rounded-lg hover:bg-gray-900 focus:ring-4 focus:outline-none dark:text-white focus:ring-gray-700 dark:bg-gray-900 dark:hover:bg-gray-800 dark:focus:ring-gray-600"
                  type="button"
                >
                  <svg
                    class="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 4 15"
                  >
                    <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                  </svg>
                </button>
                <div
                  id="dropdownDots"
                  class="z-10 hidden bg-gray-700 divide-y divide-gray-100 rounded-lg shadow w-40 dark:bg-gray-700 dark:divide-gray-600"
                >
                  <ul
                    class="py-2 text-sm text-gray-200 dark:text-gray-200"
                    aria-labelledby="dropdownMenuIconButton"
                  >
                    <li>
                      <a
                        href="#"
                        class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Reply
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Forward
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Copy
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Report
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        Delete
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex items-center  w-full bg-neutral-900 rounded-full border-[1px] border-[#1f2734]">
                <button className="p-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="white"
                    className="size-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 4.5v15m7.5-7.5h-15"
                    />
                  </svg>
                </button>
                <input
                  className="flex-grow p-2 bg-neutral-900 text-white rounded-xl focus:outline-none"
                  placeholder="Type a message..."
                />
                <button className="p-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="white"
                    className="size-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
                    />
                  </svg>
                </button>
                <button className="p-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="white"
                    className="size-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoDetails;
